import { create } from 'zustand'
import type { AuthStore } from '../types'

export const useAuthStore = create<AuthStore>()((set) => ({
    isAuth: false,
    isLoading: true,
    setIsAuth: (isAuth) => set({ isAuth }),
    setIsLoading: (isLoading) => set({ isLoading })
}))
